import { render, staticRenderFns } from "./TrainingPlanItemNutrition.vue?vue&type=template&id=52cfad99&scoped=true&"
import script from "./TrainingPlanItemNutrition.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanItemNutrition.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingPlanItemNutrition.vue?vue&type=style&index=0&id=52cfad99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cfad99",
  null
  
)

export default component.exports